export default {
    EM_ESPERA: 1,
    EM_ATENDIMENTO: 2,
}